import React from "react";
import "./index.css";
import { t } from "i18next";
const PrivatePolicyPage = () => {
  return (
    <>
      <div className="policy-hero">
        <h3 className="policy-hero-heading remove-pointer-events">
          {t("privacyPolicy")}
        </h3>
      </div>
      <div className="policy-container remove-pointer-events">
        <p className="policy-text">{t("policyPrivacyHeading")}</p>

        <h3 className="policy-heading">{t("policyPrivacyFirstHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyFirstDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacySecondHeading")}</h3>

        <p className="policy-text">{t("policyPrivacySecondDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyThirdHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyThirdDescription")}</p>
        <h3 className="policy-heading">{t("policyPrivacyFourHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyFourDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyFiveHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyFiveDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacySixHeading")}</h3>

        <p className="policy-text">{t("policyPrivacySixDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacySevenHeading")}</h3>

        <p className="policy-text">{t("policyPrivacySevenDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyEightHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyEightDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyNineHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyNineDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyTenHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyTenDescription")}</p>

        <h3 className="policy-heading">{t("policyPrivacyElevenHeading")}</h3>

        <p className="policy-text">{t("policyPrivacyElevenDescription")}</p>
      </div>
      <div style={{ height: "50px" }}></div>
    </>
  );
};

export default PrivatePolicyPage;
